/**语音回复的字段 */
import { BaseModel } from '../BaseModel';

export class WxVoid extends BaseModel {
    VoiceId: number = 0
    Type: number = 1
    VoiceTitle: string = ""
    VoiceLink: string = ""
    HighLink: string = ""
    Description: string = ""
    Keyword: string = ""
    ReallyImage: string = ""
    State: number = 1
    Nature:number=0
    MediaId:string=""
}